module.exports = __webpack_public_path__ + "static/media/poste_1.3cf348a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_1.jpg
// module id = 237
// module chunks = 0